<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import { type Component, computed, PropType } from "vue";

const props = defineProps({
    href: {
        type: String,
        default: "",
    },
    active: {
        type: Boolean,
        required: false,
    },
    label: {
        type: String,
        default: "",
    },
    expanded: {
        type: Boolean,
        default: false,
    },
    icon: {
        type: Object as PropType<Component>,
        required: true,
    },
    iconActive: {
        type: Object as PropType<Component>,
        required: true,
    },
});

const classes = computed(() => (props.active ? "bg-gray-300 font-semibold" : ""));
const iconClasses = computed(() => (props.active ? "fill-white bg-gray-900" : "fill-gray-900 bg-transparent"));

const navIcon = computed(() => (props.active ? props.iconActive : props.icon));
</script>

<template>
    <Link
        :href="href"
        class="flex h-12 items-center justify-start gap-x-3 overflow-clip rounded-full p-1 hover:bg-gray-400"
        :class="classes"
    >
        <span
            class="flex h-10 w-10 flex-none items-center justify-center rounded-full"
            :class="iconClasses"
        >
            <Component
                :is="navIcon"
                class="h-5"
            />
        </span>

        <span
            class="flex-none transition-all"
            :class="{ '': expanded, 'opacity-0': !expanded }"
        >
            {{ label }}
        </span>
    </Link>
</template>
